<template>
  <Dialog v-model="dialogVisible" :title="dialogTitle" width="1000px">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="线索来源" prop="source">
            <el-select v-model="formData.source" placeholder="请选择线索来源" class="w-1/1">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_SOURCE)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="来访关键词" prop="visitKeyword">
            <el-input
              v-model="formData.visitKeyword"
              placeholder="请输入来访关键词"
              :maxlength="255"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人姓名" prop="contactName">
            <el-input
              v-model="formData.contactName"
              placeholder="请输入联系人姓名"
              :maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司名称" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入公司名称"
              :maxlength="128"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机" prop="mobile">
            <el-input
              v-model="formData.mobile"
              placeholder="请输入手机"
              :maxlength="20"
              @input="(v: string) => (formData.mobile = onlyDigits(v))"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话" prop="telephone">
            <el-input
              v-model="formData.telephone"
              placeholder="请输入电话"
              :maxlength="20"
              @input="(v: string) => (formData.telephone = onlyPhone(v))"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="微信号" prop="wechat">
            <el-input
              v-model="formData.wechat"
              placeholder="请输入微信号"
              :maxlength="255"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="QQ号" prop="qq">
            <el-input v-model="formData.qq" placeholder="请输入 QQ 号" :maxlength="20" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="产品" prop="product">
            <el-input
              v-model="formData.product"
              placeholder="请输入产品"
              :maxlength="255"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱" prop="email">
            <el-input
              v-model="formData.email"
              placeholder="请输入邮箱"
              :maxlength="255"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="留言信息" prop="message">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.message"
              placeholder="请输入留言信息"
              :maxlength="1000"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="谁跟" prop="followerUserId">
            <el-select
              v-model="formData.followerUserId"
              clearable
              filterable
              placeholder="请选择跟进人"
              class="w-1/1"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="下次跟进时间" prop="contactNextTime">
            <el-date-picker
              v-model="formData.contactNextTime"
              placeholder="选择下次跟进时间"
              type="datetime"
              value-format="x"
              class="!w-1/1"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="来访时间" prop="visitTime">
            <el-date-picker
              v-model="formData.visitTime"
              placeholder="选择来访时间"
              type="datetime"
              value-format="x"
              class="!w-1/1"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="负责人" prop="ownerUserId">
            <el-select
              v-model="formData.ownerUserId"
              :disabled="formType !== 'create'"
              class="w-1/1"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="需求概述" prop="requirement">
            <el-input
              v-model="formData.requirement"
              placeholder="请输入需求概述"
              :maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="跟进状态" prop="followUpStatus">
            <el-select v-model="formData.followUpStatus" class="w-1/1">
              <el-option :value="false" label="未跟进" />
              <el-option :value="true" label="已跟进" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户级别" prop="level">
            <el-select
              v-model="formData.level"
              clearable
              placeholder="请选择客户级别"
              class="w-1/1"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_LEVEL)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="城市" prop="areaId">
            <el-cascader
              v-model="formData.areaId"
              :options="areaList"
              :props="defaultProps"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择城市"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="IP" prop="ip">
            <!-- 键入即只留 0-9 a-f . :（挡住汉字/空格/斜杠）；是否为合法地址由 rules 的 ipAddress 校验 -->
            <el-input
              v-model="formData.ip"
              placeholder="请输入 IP"
              :maxlength="64"
              @input="(v: string) => (formData.ip = onlyIpChars(v))"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户行业" prop="industryId">
            <el-select
              v-model="formData.industryId"
              clearable
              placeholder="请选择客户行业"
              class="w-1/1"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_INDUSTRY)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮编" prop="zipCode">
            <el-input v-model="formData.zipCode" placeholder="请输入邮编" :maxlength="16" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="地址" prop="detailAddress">
            <el-input
              v-model="formData.detailAddress"
              placeholder="请输入详细地址"
              :maxlength="255"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="详细需求" prop="detailRequirement">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.detailRequirement"
              placeholder="请输入详细需求"
              :maxlength="2000"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.remark"
              placeholder="请输入备注"
              :maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="申请人">{{ applicantName }}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>
<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import * as ClueApi from '@/api/crm/clue'
import * as AreaApi from '@/api/system/area'
import { defaultProps } from '@/utils/tree'
import * as UserApi from '@/api/system/user'
import { getCurrentUserId } from '@/utils/auth'
import { onlyDigits, onlyIpChars, onlyPhone } from '@/utils/inputFilter'
import { ipAddress, notPureNumber } from '@/utils/formRules'

const { t } = useI18n() // 国际化
const message = useMessage() // 消息弹窗

const dialogVisible = ref(false) // 弹窗的是否展示
const dialogTitle = ref('') // 弹窗的标题
const formLoading = ref(false) // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
const formType = ref('') // 表单的类型：create - 新增；update - 修改
const areaList = ref([]) // 地区列表
const userOptions = ref<UserApi.UserVO[]>([]) // 用户列表
const applicantName = ref('') // 申请人名称（只读）
const formData = ref({
  id: undefined,
  name: undefined,
  contactName: undefined,
  source: undefined,
  visitKeyword: undefined,
  mobile: undefined,
  telephone: undefined,
  wechat: undefined,
  qq: undefined,
  product: undefined,
  message: undefined,
  email: undefined,
  followerUserId: undefined,
  contactNextTime: undefined,
  visitTime: undefined,
  ownerUserId: 0,
  requirement: undefined,
  followUpStatus: false,
  level: undefined,
  areaId: undefined,
  ip: undefined,
  industryId: undefined,
  zipCode: undefined,
  detailAddress: undefined,
  detailRequirement: undefined,
  remark: undefined
})
const formRules = reactive({
  // 公司名称不能是纯数字：`required` 只拦空值，`123456` 这类会一路存进库
  name: [
    { required: true, message: '公司名称不能为空', trigger: 'blur' },
    notPureNumber('公司名称')
  ],
  // 邮箱非必填：有值时才校验格式（async-validator 对空值自动跳过 type 校验）
  email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
  // IP 非必填：有值时才校验格式（IPv4 / IPv6）。空值放行，必填不在此处
  ip: [ipAddress('IP')],
  ownerUserId: [{ required: true, message: '负责人不能为空', trigger: 'blur' }]
})
const formRef = ref() // 表单 Ref

/** 打开弹窗 */
const open = async (type: string, id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  // 修改时，设置数据
  if (id) {
    formLoading.value = true
    try {
      formData.value = await ClueApi.getClue(id)
    } finally {
      formLoading.value = false
    }
  }
  // 获得地区列表
  areaList.value = await AreaApi.getAreaTree()
  // 获得用户列表
  userOptions.value = await UserApi.getSimpleUserList()
  // 默认新建时选中自己，并预填来访时间
  if (formType.value === 'create') {
    formData.value.ownerUserId = getCurrentUserId()
    formData.value.visitTime = Date.now()
  }
  // 申请人（只读）：创建时为当前登录用户，其余情况取创建人
  const applicant = userOptions.value.find(
    (item) => item.id === (formData.value.id ? Number(formData.value.creator) : getCurrentUserId())
  )
  applicantName.value = applicant?.nickname ?? ''
}
defineExpose({ open }) // 提供 open 方法，用于打开弹窗

/** 提交表单 */
const emit = defineEmits(['success']) // 定义 success 事件，用于操作成功后的回调
const submitForm = async () => {
  // 校验表单
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  // 提交请求
  formLoading.value = true
  try {
    const data = formData.value as unknown as ClueApi.ClueVO
    if (formType.value === 'create') {
      await ClueApi.createClue(data)
      message.success(t('common.createSuccess'))
    } else {
      await ClueApi.updateClue(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    // 发送操作成功的事件
    emit('success')
  } finally {
    formLoading.value = false
  }
}

/** 重置表单 */
const resetForm = () => {
  formData.value = {
    id: undefined,
    name: undefined,
    contactName: undefined,
    source: undefined,
    visitKeyword: undefined,
    mobile: undefined,
    telephone: undefined,
    wechat: undefined,
    qq: undefined,
    product: undefined,
    message: undefined,
    email: undefined,
    followerUserId: undefined,
    contactNextTime: undefined,
    visitTime: undefined,
    ownerUserId: 0,
    requirement: undefined,
    followUpStatus: false,
    level: undefined,
    areaId: undefined,
    ip: undefined,
    industryId: undefined,
    zipCode: undefined,
    detailAddress: undefined,
    detailRequirement: undefined,
    remark: undefined
  }
  applicantName.value = ''
  formRef.value?.resetFields()
}
</script>
